setUserAccountDataBillingSubscriptionsWithDetails